import React, { FC } from 'react';
import { Box, Unstable_Grid2 as Grid } from '@mui/material';
import { times } from 'lodash';

import { LoaderComponents, PaddedPaper } from 'components';

const GridLoader: FC = () => {
  const { Block, Image } = LoaderComponents;

  return (
    <Grid container spacing={2}>
      {times(4, rowIndex => (
        <Grid key={rowIndex} xs={12} sm={6} md={4} lg={3}>
          <PaddedPaper sx={{ position: 'relative', height: 300 }}>
            <Grid container direction="column" justifyContent="flex-end" sx={{ height: '100%' }}>
              <Grid xs>
                <Box marginBottom={2} display="flex" justifyContent="center">
                  <Image shape="circular" height={100} width={100} />
                </Box>
                <Grid container direction="column" alignItems="center">
                  <Grid>
                    <Block height={20} width={150} />
                  </Grid>
                  <Grid>
                    <Block width={150} />
                  </Grid>
                  <Grid>
                    <Block height={25} width={200} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid>
                <Block height={30} width="100%" />
              </Grid>
            </Grid>
          </PaddedPaper>
        </Grid>
      ))}
    </Grid>
  );
};

export default GridLoader;
